import styled from "styled-components";

export const TimerBadgeStyled = styled.div`
    display: flex;
    gap: 4px;
    border-radius: 12px;
    padding: 4px 8px 4px 4px;
    background: var(--color-yellow-80);
    font-weight: 600;
    color: var(--text-color-dark);

    span {
        white-space: nowrap;
    }
`;
